import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import EmailOtpVerification from "../components/EmailOtpVerification";

function EmailOtpVerificationSignup() {
  const location = useLocation<any>();
  const history = useHistory<any>();

  const urlSearchParams = new URLSearchParams(location.search);
  const emailParam = urlSearchParams.get('email');
  const redirectUrl = urlSearchParams.get('redirect_to');
  const oauthFlow = urlSearchParams.get('oauth_flow');
  const isOAuthFlow = oauthFlow === '1' || oauthFlow === 'true';
  const currentSearch = location.search;
  const { state } = location;
  const emailFromState = state?.email;

  const [email, setEmail] = useState<string>("");
  const [autoSendOtp, setAutoSendOtp] = useState(false);
  const [otpAlreadySent, setOtpAlreadySent] = useState(false);

  useEffect(() => {
    // Get email from state (from signup redirect) or query params
    const emailToUse = emailFromState || emailParam;
    if (emailToUse) {
      setEmail(emailToUse);
      // If email comes from signup state, OTP was already sent during signup
      // Show OTP input fields directly without "Send OTP" button
      if (emailFromState) {
        setOtpAlreadySent(true);
        setAutoSendOtp(false);
        // Start the timer for resend (default 1 minute)
        // We don't set initialDelay here, just mark as already sent
      } else if (emailParam) {
        // Email from query params - auto-send OTP
        setAutoSendOtp(true);
        setOtpAlreadySent(false);
      }
    }
  }, [emailParam, emailFromState]);

  const handleVerifySuccess = (response: any) => {
    // After OTP verification, email is verified and user can login
    // If refresh_token is returned, user is already logged in
    if (response?.data?.refresh_token) {
      // User is logged in, redirect to dashboard
      if (redirectUrl) {
        try {
          const redirectTo = new URL(redirectUrl, window.location.origin);
          window.location.href = redirectTo.href;
        } catch (e) {
          history.push({
            pathname: "/",
            state: { response: true, message: "Account verified and logged in successfully" },
          });
        }
      } else {
        history.push({
          pathname: "/",
          state: { response: true, message: "Account verified and logged in successfully" },
        });
      }
    } else {
      // Email verified but need to login
      history.push({
        pathname: "/login",
        search: currentSearch,
        state: {
          response: true,
          message: "Email verified successfully. Please login to continue.",
          verifiedEmail: email
        },
      });
    }
  };

  if (!email) {
    return null;
  }

  return (
    <RightBanner $isOAuthFlow={isOAuthFlow}>
      {!isOAuthFlow && <Text>Hey, Hello</Text>}
      <Heading $isOAuthFlow={isOAuthFlow}>
        {isOAuthFlow ? "Verify OTP" : "Verify Your Email OTP"}
      </Heading>
      <OTPContainer>
        <EmailOtpVerification
          email={email}
          mode="signup"
          autoSendOtp={autoSendOtp}
          otpAlreadySent={otpAlreadySent}
          isOAuthFlow={isOAuthFlow}
          redirectUrl={redirectUrl}
          onVerifySuccess={handleVerifySuccess}
          onEmailChange={(newEmail) => setEmail(newEmail)}
        />
      </OTPContainer>
    </RightBanner>
  );
}

export default EmailOtpVerificationSignup;

const RightBanner = styled.div<{ $isOAuthFlow?: boolean }>`
  padding: 40px 100px;
  width: 100%;
  @media (max-width: 576px) {
    padding: 0px 0px;
  }
`;

const Heading = styled.h1<{ $isOAuthFlow?: boolean }>`
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: ${props => props.$isOAuthFlow ? '#333333' : '#073b5f'};
  @media (max-width: 576px) {
    font-size: 20px;
  }
`;

const Text = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #93acbd;
  margin: 0;
  @media (max-width: 576px) {
    font-size: 12px;
  }
`;

const OTPContainer = styled.div`
  width: 50%;
  margin: 40px auto;
  @media (max-width: 576px) {
    width: 100%;
  }
`;